/**
 * Created by rkamysz on 3/9/2015.
 */

// import { IMeasurementContext } from "../api/IMeasurementContext";
// import { IMeasurementFacade } from "../api/IMeasurementFacade";
// import { ContextManager } from "./core/ContextManager";
// import { ConditionsHelper } from "./helpers/ConditionsHelper";
// import { objectAsString } from "./helpers/objectAsString";
// import { validateMeasurementClasses } from "./helpers/validateMeasurementClasses";
// import { MeasurementComponentsBundle } from "./measurementBase/MeasurementComponentsBundle";
// import { MeasurementContext } from "./measurementBase/MeasurementContext";

import { IMeasurementFacade, FPS_MEASUREMENT_LOGGER } from "./IMeasurements";
import { MeasurementFacade } from "./MeasurementFacade";

import { getLogger } from "@goodgamestudios/logger";

export class Measurements {

    private logger = getLogger(FPS_MEASUREMENT_LOGGER);
    /**
     * This is method create the measurement, based on provided classes.
     * By using different names you can create many instances of same measurement - if needed - but you can't use same name twice.
     * You can set conditions which should be fulfilled before creating measurement.
     *
     * @param measurementClass Class which must implement <code>IMeasurement</code>
     * @param configClass Class which must implement <code>IMeasurementConfig</code>
     * @param name Name of the measurement. If you leave this as null,
     * the name will be generated from measurement class name.
     * @param conditions Conditions for creating the measurement.
     * @return This method returns object of <code>MeasurementFacade</code>.
     *
     * @see IMeasurementFacade
     */
    public static createMeasurement(measurementClass: Object, configClass: Object, name: string = null, conditions: any[] = null): IMeasurementFacade {
        // validateMeasurementClasses(measurementClass, configClass);

        // if (!name) {
        //     name = objectAsString(measurementClass);
        // }

        // let context: IMeasurementContext = (<IMeasurementContext>ContextManager.getInstance(name, MeasurementContext));

        // if (!context.installed && ConditionsHelper.areFulfilled(conditions)) {
        //     context.setupMeasurement(measurementClass, configClass);
        //     context.installComponents(MeasurementComponentsBundle);
        // }

        let facade: IMeasurementFacade = new MeasurementFacade();
        getLogger("FPSMeasurement").debug("Measurements.createMeasurement is not implemented yet");

        return facade;
    }

    /**
     * By this method you can use measurement instance.
     *
     * @param name Name of the measurement instance.
     * @return This method returns object of <code>MeasurementFacade</code>.
     *
     * @see IMeasurementFacade
     */
    public static getMeasurement(name: string): IMeasurementFacade {
        // return ((<IMeasurementContext>ContextManager.getInstance(name))).facade;
        let facade: IMeasurementFacade = new MeasurementFacade();
        getLogger("FPSMeasurement").debug("Measurements.getMeasurement is not implemented yet");
        return facade;
    }

    /**
     * With this method you can remove specific measurement instance.
     *
     * @param name Name of the measurement instance.
     */
    public static removeMeasurement(name: string): void {
        // ContextManager.removeInstance(name);
        getLogger("FPSMeasurement").debug("Measurements.removeMeasurement is not implemented yet");
    }

    /**
     * With this method you can remove all measurement instances of given class
     *
     * @param measurementClass Class of the measurement
     */
    public static removeMeasurementsOf(measurementClass: Object): void {
        // ContextManager.removeMeasurementsOf(measurementClass);
        getLogger("FPSMeasurement").debug("Measurements.removeMeasurementsOf is not implemented yet");
    }
}
